module.exports = __webpack_public_path__ + "static/media/musir.b6647763.png";